import { Link } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";
import { LI, UL } from "../../../../../AbstractElements";
import { Href, PopularTagsTitle } from "../../../../../Constants/Constants";
import { PopularTagsData } from "../../../../../Data/Miscellaneous/Blog";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const PopularTags = () => {
  return (
    <>
      <Col sm="12">
        <Card>
          <CommonCardHeader title={PopularTagsTitle} headClass="pb-0 border-0" />
          <CardBody>
            <UL className="tags simple-list">
              {PopularTagsData.map((item, index) => (
                <LI key={index}>
                  <Link to={Href}>{item}</Link>
                </LI>
              ))}
            </UL>
          </CardBody>
        </Card>
      </Col>
      
    </>
  );
};

export default PopularTags;
